import React from "react";

import zparse from "helpers/zparse";

const Headline = props => {
	let { image, title, body, columnSize = 4, bgColor, color, type, isPageHeader, preTitle } = props;
	if (isPageHeader === undefined) isPageHeader = false;
	if (type === "bg-color") {
		image = "";
	} else if (type === "no-bg") {
		image = "";
		bgColor = "";
	} else {
		bgColor = "";
	}
	if (type === "no-header") return null;
	if (!title) return null;
	const isHtml = /<\/?[a-z][\s\S]*>/i;

	const headlineStyle = {
		background: `linear-gradient(90deg, rgba(17, 74, 101, 0.75) 0%, rgba(1, 31, 43, 0.00) 100%), url('${image}') center center / cover no-repeat`,
		...(type === "bg-color" ? { 
			background: 'none',
			backgroundColor: bgColor, 
		} : {})
	}

	return (
		<div className={`headline ${(!image && !bgColor) ? "no-shadow" : ""} ${isPageHeader ? `page-header` : ""}`} style={headlineStyle}>
			<div className="grid-container">
				<div className={`grid-x grid-padding-x ${isPageHeader ? "align-middle small-align-center" : ""}`}>
					<div className={`cell small-11 small-order-1 medium-order-2 medium-${columnSize} content-block`}>
						{preTitle && <small style={{ color }}>{zparse(preTitle)}</small>}
						{isPageHeader ? <h1 style={{ color }}>{zparse(title)}</h1> : <h2 style={{ color }}>{zparse(title)}</h2>}
						{body && (isHtml.test(body) ? zparse(body) : <p style={{ color }}>{body}</p>)}
					</div>
				</div>
			</div>
		</div>
	)
}

export default Headline;